import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import MainHeader from "../../components/MainHeader/MainHeader";
import Box from "@mui/material/Box";
import DocumentShow from "../../components/Document/DocumentShow";
import "../AddApplic/styles.scss";
import "../../components/AddForm1/form.scss";
import {
  FileDoneOutlined,
  SolutionOutlined,
  FileWordOutlined,
  WechatOutlined,
} from "@ant-design/icons";
import { Steps, Tabs } from "antd";
import {
  useNavigate,
  useSearchParams,
  createSearchParams,
} from "react-router-dom";
import ShowApplic from "../../components/ShowApplic/ShowApplic";
import "../../components/ShowApplic/styles.scss";
import Xronology from "../../components/Xronology/Xronology";
import Payshow from "../../components/Pay/Payshow";
import { Button, notification, Tooltip } from "antd";
import Chat from "../../components/Chat/Chat";
import Intruction from "../../components/Intruction/Intruction";
import ShowInstruction from "../../components/Intruction/ShowInstruction";
function ShowApplication({ t }) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { TabPane } = Tabs;
  const handlenext = () => {
    navigate("/account/applications/document");
  };
  const handleback = () => {
    navigate("/account/applications");
  };
  function selects(key) {
    switch (key) {
      case "1":
        return (
          <div className="form-body ap-layout">
            <div className="ap-layout__main">
              <ShowApplic handlenext={handlenext} id={searchParams.get("id")} />
            </div>
            <div className="ap-layout__aside">
              <Xronology />
            </div>
          </div>
        );
      case "2":
        return (
          <div className="form-body ">
            <div>
              <DocumentShow />
            </div>
          </div>
        );
      case "3":
        return (
          <div className="form-body ">
            <div>
              <ShowInstruction />
            </div>
          </div>
        );
      // case "4":
      //   return (
      //     <div className="form-body ">
      //       <div>
      //         <Chat />
      //       </div>
      //     </div>
      //   );

      default:
        break;
    }
  }
  const [keys, setKeys] = useState("1");

  const changeTab = (activeKey) => {
    setKeys(activeKey);
  };
  return (
    <div>
      <div className="af-tabs">
        {[
          ["1", <SolutionOutlined />, t("Application")],
          ["3", <FileDoneOutlined />, t("Instruction")],
          ["2", <FileWordOutlined />, t("Document")],
        ].map(([key, icon, label]) => (
          <button
            type="button"
            key={key}
            className={keys === key ? "af-tab af-tab--active" : "af-tab"}
            onClick={() => changeTab(key)}
          >
            {icon}
            <span>{label}</span>
          </button>
        ))}
      </div>
      {selects(keys)}
      <div className="af-back">
        <Button size="large" onClick={handleback}>
          ← {t("Back")}
        </Button>
      </div>
    </div>
  );
}
export default withTranslation()(ShowApplication);
